/**
 * Admin guide 5 — editing during the day: saves reach today's unsent
 * drafts, a prompt change re-writes their texts, hand edits are never
 * touched, verdicts and lists change the rest of the day.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenEngineSettings } from '@trafficpulse/shared';

import { Points, Rows, V } from '../guide-ui';

export const EditingSection: FC<{ s: DropGenEngineSettings }> = ({ s }) => (
  <div className="flex flex-col gap-3">
    <Rows
      stamp="What a change does to today's drafts"
      head={['You change', 'Today\'s unsent drafts']}
      rows={[
        ['Any save · Generate now', 'Time, amount, gateway, list and send options follow at once'],
        ['The prompt groups', <>New texts; old ones stay until the new land — drafts due within <V>{s.rewriteLeadMin} min</V> keep theirs</>],
        ['A draft by hand', 'Pinned: the engine never changes it again'],
        ['Skip a slot', 'Its draft goes, and stays skipped until Reset'],
        ['Sent or staged drops', 'Never change'],
      ]}
    />
    <Points
      items={[
        <>The engine owns its drafts while they are <b>unsent and not staged</b>.</>,
        <><b>Verdicts</b> change the rest of the day: scaling (next drops bigger or smaller), burn (the list leaves; with Stop list, today's rest stops), gateway block (drops move), hit again (a new drop now).</>,
        <><b>Lists</b>: Generate now and the daily auto-generate start a formula group on its formula's best list (dynamic groups with today's tags); a re-sync keeps today's list until it burns or runs dry. Saving a rule, order or formula picks again, and so does Refresh lists.</>,
        <><b>Master config</b>: a container that follows a section uses the master's value live; its own values stay until “Override all containers”.</>,
      ]}
    />
  </div>
);
